import {
  ClassNameMap,
  TypographyClasses,
  TypographyProps,
} from "@mui/material";
import { HTMLAttributes } from "react";
import { MuiGrid } from "../grid/MuiGrid";
import { MuiTypography } from "../typography/MuiTypography";
import { MuiDoubleLabelHorizontalWrapper } from "./MuiDoubleLabelHorizontal.style";

interface MuiDoubleLabelHorizontalProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  value?: string | React.ReactNode;
  labelTypoVariant?: TypographyProps["variant"];
  valueTypoVariant?: TypographyProps["variant"];
  labelClasses?:
    | (Partial<TypographyClasses> & Partial<ClassNameMap<never>>)
    | undefined;
  valueClasses?:
    | (Partial<TypographyClasses> & Partial<ClassNameMap<never>>)
    | undefined;
}

export const MuiDoubleLabelHorizontal = ({
  label,
  value,
  labelTypoVariant = "h3Bold",
  valueTypoVariant = "h3Bold",
  labelClasses,
  valueClasses,
  ...rest
}: MuiDoubleLabelHorizontalProps) => {
  return (
    <MuiDoubleLabelHorizontalWrapper {...rest}>
      <MuiTypography variant={labelTypoVariant} classes={labelClasses}>
        {label}
      </MuiTypography>

      <MuiGrid className="value-container">
        <MuiTypography variant={valueTypoVariant} classes={valueClasses}>
          {value}
        </MuiTypography>
      </MuiGrid>
    </MuiDoubleLabelHorizontalWrapper>
  );
};
